import { render, staticRenderFns } from "./BidsOnMap.vue?vue&type=template&id=10f76ad4&"
import script from "./BidsOnMap.vue?vue&type=script&lang=js&"
export * from "./BidsOnMap.vue?vue&type=script&lang=js&"
import style0 from "./BidsOnMap.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports